import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons } from '../icons';

export default class ToursCluster extends Component {

    componentDidMount() {

        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }


    zoom() {
        this.props.map.setZoom(this.props.zoom+2);
        this.props.map.setCenter({lat: this.props.lat, lng: this.props.lng});
    }

    selectTour(tour) {

        this.props.actions.selectMapTour(tour);
        this.props.actions.fetchPostsIfNeeded(1, tour.id);
    }

    render () {

        let active = false;
        this.props.tours.forEach(function(tour){
            if (!tour.hidden) {
                active = true;
                return false;
            }
        });



        return (
            <div  className="map__info" style={{position: 'absolute'}} >
                <div onClick={this.zoom.bind(this)} className={"map__tour_cluster map__tour " + ((this.props.count > 9)?"map__tour_cluster_10 ":" ") + (!active?'map__tour_cluster_hidden':'')}>
                    {this.props.count}
                </div>

                <div className="map__balloon map__balloon_tours">
                        {this.props.tours.map((tour, i)=>
                        <div key={i} onClick={this.selectTour.bind(this, tour)} className={"map__link " + (tour.hidden?'map__link_hidden':'')}>
                            {tour.title}
                        </div>
                        )}
                </div>
            </div>



        );
    }
};



// WEBPACK FOOTER //
// ./src/common/components/map/ToursCluster.js